// extracted by mini-css-extract-plugin
export default {"header":"search-header_header__oZJnB","search":"search-header_search__yjcyx"};